import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import requestPaymentMethodEdit from './request/requestPaymentMethodEdit'
import requestPaymentMethodRegister from './request/requestPaymentMethodRegister'

const Actions = {
  // PM01 入出金手段一覧取得
  getPaymentMethodListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.PAYMENT_METHOD_LIST)
      .get(api.PAYMENT_METHOD_LIST, { params: params })
      .then((response) => {
        const path = mutationsTypes.PAYMENT_METHOD_SET_PAYMENT_METHOD_LIST
        commit(path, response.data.data)
        const getData = getters.getPaymentMethodListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // PM02 入出金手段登録
  registerPaymentMethod: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestPaymentMethodRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.PAYMENT_METHOD_REGISTER_EDIT)
      .post(api.PAYMENT_METHOD_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // PM03 入出金手段編集
  editPaymentMethod: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = requestPaymentMethodEdit.request.createRequest(params)

    return await axios
      // .get(apiMock.PAYMENT_METHOD_REGISTER_EDIT)
      .patch(`${api.PAYMENT_METHOD_REGISTER_EDIT}/${params.id}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
